import Spinner from "Components/RequestHandler/Spinner";
import { Plus, Check, CheckCircle } from "@phosphor-icons/react";
import MainButton from "Components/Button/MainButton";
import { useContext, useState } from "react";
import { LoginContext } from "context/Auth/LoginContext";
import { CartContext } from "context/Cart/CartContext";
import VerificationModal from "Components/Modal/VerificationModal";
import LoginModal from "Components/Modal/LoginModal";
import PendingCartModal from "Components/Modal/PendingCartModal";
import { useNavigate } from "react-router-dom";
import IMAGE_URL from "Utilities/IMAGE_URL";
import { useTranslation } from "react-i18next";
import Pagination from "Components/Pagination/Pagination";

const CourseDisplay = ({ courses, loading, pagination, onPageChange }) => {
  const { t } = useTranslation();
  const { addToCart, isItemLoading, isItemInCart, cart } =
    useContext(CartContext);
  const { token, isLoggedIn, isVerified, user } = useContext(LoginContext);
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showPendingCartModal, setShowPendingCartModal] = useState(false);
  const navigate = useNavigate();

  // Check if a course is owned by the user
  const isCourseOwned = (courseSlug) => {
    if (!user?.purchasedItems?.courses) return false;
    return user.purchasedItems.courses.some(
      (purchased) => purchased.slug === courseSlug
    );
  };

  const handleAddToCart = (course) => {
    if (!isLoggedIn) {
      setShowLoginModal(true);
    } else if (isLoggedIn && !isVerified) {
      setShowVerificationModal(true);
    } else if (cart?.status === "pending") {
      setShowPendingCartModal(true);
    } else {
      addToCart(
        {
          type: "course",
          slug: course.slug,
        },
        token
      );
    }
  };

  const handleVerificationLater = () => {
    setShowVerificationModal(false);
    navigate("/");
  };

  const handleVerification = () => {
    navigate("/verify-email", { state: { email: user?.email } });
    setShowVerificationModal(false);
  };
  return (
    <div className=" lg:col-span-9">
      {loading ? (
        <div className="flex justify-center">
          <Spinner />
        </div>
      ) : courses.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          {t("courses.noCoursesAvailable")}
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-12 font-text">
          {courses.map((course) => (
            <div key={course._id} className="">
              <div className="h-[300px] w-full overflow-hidden relative">
                <img
                  src={`${IMAGE_URL}/${course?.image}`}
                  alt={course.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-0 left-0 w-full h-full bg-black/30 flex items-center justify-center">
                  <h3 className="font-bold text-2xl capitalize text-white mb-2">
                    {course.title}
                  </h3>
                </div>
              </div>
              <div className="mt-2">
                <div>
                  <p className="text-primary mb-2">
                    {course?.category?.title ||
                      course?.category?.translations?.en?.title}
                  </p>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-xl text-dark text-gray-500 font-medium capitalize">
                    {isCourseOwned(course.slug) ? (
                      <span className="text-green-600 flex items-center gap-1">
                        <CheckCircle weight="fill" />
                        {t("account.purchased")}
                      </span>
                    ) : (
                      <>
                        {t("courses.price")} {course.price}$
                      </>
                    )}
                  </span>

                  <div className="flex items-stretch gap-2 relative">
                    {!isCourseOwned(course.slug) && (
                      <button
                        onClick={() => handleAddToCart(course)}
                        className="border border-primary text-primary rounded-md px-2 "
                        title={t("courses.addToCart")}
                      >
                        {isItemLoading("course", course.slug) ? (
                          <Spinner isSmall={true} />
                        ) : isItemInCart("course", course.slug) ? (
                          <Check />
                        ) : (
                          <Plus />
                        )}
                      </button>
                    )}
                    <MainButton
                      to={`/course-detailes/${course.slug}`}
                      isOutline={true}
                      isSmall={true}
                    >
                      {t("courses.watchCourse")}
                    </MainButton>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <VerificationModal
        isOpen={showVerificationModal}
        onClose={handleVerificationLater}
        onVerify={handleVerification}
        email={user?.email}
      />
      <LoginModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
      />
      <PendingCartModal
        isOpen={showPendingCartModal}
        onClose={() => setShowPendingCartModal(false)}
      />

      {/* Pagination */}
      {!loading && courses.length > 0 && pagination && (
        <div className="mt-16">
          <Pagination
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
            totalCount={pagination.totalCount}
            pageSize={pagination.pageSize}
            hasNextPage={pagination.hasNextPage}
            hasPrevPage={pagination.hasPrevPage}
            onPageChange={onPageChange}
          />
        </div>
      )}
    </div>
  );
};

export default CourseDisplay;
